let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("721i7")).then(() => parcelRequire('g76iG'));